<div class="dialog">
  @if (isMobileView) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="closeDialog()" class="task-header-action" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Profile Image' | translate }} {{ 'Update' | translate | lowercase }}</h2>
      <p (click)="save()" [class.disabled]="isLoading" class="task-header-action" translate>Save</p>
    </header>
  } @else {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Profile Image' | translate }} {{ 'Update' | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="closeDialog()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form">
      <app-image-selector
        (imageSelected)="selectedImage = $event"
        [aspectRatio]="1"
        [emitBase64]="true"
        [format]="'png'"
        [hideClearButton]="true"
        [imageCropper]="true"
        [isRoundedPreview]="true"
        formControlName="image"
      ></app-image-selector>
    </form>
  </div>

  <footer>
    @if (!isMobileView) {
      <div class="dialog__footer">
        <div class="dialog__footer__buttons">
          <app-button (click)="closeDialog()" [disabled]="isLoading" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="isLoading || form.pristine" [idleText]="'Save' | translate"></app-button>
        </div>
      </div>
    } @else {
      <div class="mobile-button mx-16 mb-34">
        <app-button (clickEvent)="save($event)" [disabled]="isLoading || form.pristine" [idleText]="'Save' | translate" [isLoading]="isLoading" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
